// extracted by mini-css-extract-plugin
export default {"ToolsContainer":"styles_ToolsContainer__GXHoN","MySkills":"styles_MySkills__afiSH","ordinary":"styles_ordinary__H9IvB","tools":"styles_tools__+VhMM"};